import { FunctionComponent, ReactNode } from "react";

import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";

import { classNames } from "@/utils/classNames";

import { Icon } from "@/components/Icon/Icon";

interface CollapsibleFilterCardProps {
	title: string;
	description: string;
	count: number;
	isOpen: boolean;
	onToggle: () => void;
	children: ReactNode;
}

export const CollapsibleFilterCard: FunctionComponent<CollapsibleFilterCardProps> = ({
	title,
	description,
	count,
	isOpen,
	onToggle,
	children,
}) => (
	<div
		className={classNames(
			"p-4 mb-4 w-full items-start rounded-xl border border-border-light",
			"flex flex-col text-left",
			isOpen ? "bg-brand-white" : "bg-white"
		)}
	>
		<button
			className="w-full items-center justify-between group cursor-pointer flex flex-row text-left gap-6 mb-2"
			type="button"
			onClick={onToggle}
		>
			<div className="flex flex-col">
				<div className="text-smd text-text font-bold flex items-center gap-2">
					{title}
					{count > 0 && (
						<span className="inline-flex items-center justify-center rounded-full bg-blue-action px-2 py-0.5 text-xs font-medium text-white">
							{count}
						</span>
					)}
				</div>
				<div className="text-ssm text-text-meta">{description}</div>
			</div>
			<div
				className={classNames(
					"flex !min-w-[36px] !min-h-[36px] group-hover:bg-blue-action rounded-md items-center justify-center border",
					isOpen ? "border-border-light bg-white" : "border-transparent bg-background-light"
				)}
			>
				<Icon
					className="text-text-meta group-hover:text-white !w-[12px] h-auto"
					icon={isOpen ? faChevronUp : faChevronDown}
				/>
			</div>
		</button>
		{isOpen && children}
	</div>
);
